import { render, staticRenderFns } from "./ExtraTeachingNewDialog.vue?vue&type=template&id=3096b4a5"
import script from "./ExtraTeachingNewDialog.vue?vue&type=script&lang=js"
export * from "./ExtraTeachingNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports